import { render, staticRenderFns } from "./ListTwo.vue?vue&type=template&id=2c304c55&scoped=true"
import script from "./ListTwo.vue?vue&type=script&lang=js"
export * from "./ListTwo.vue?vue&type=script&lang=js"
import style0 from "./ListTwo.vue?vue&type=style&index=0&id=2c304c55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c304c55",
  null
  
)

export default component.exports